import { render, staticRenderFns } from "./TransformerForm.vue?vue&type=template&id=04fced98&scoped=true"
import script from "./TransformerForm.vue?vue&type=script&lang=ts"
export * from "./TransformerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fced98",
  null
  
)

export default component.exports